/** Logo Shynea — fallback pour les salons sans photo */
import logoShynea from '../assets/logo-shynea.png';

export const SALON_FALLBACK_IMAGE = logoShynea;

export function getSalonImage(salon) {
  if (!salon) return SALON_FALLBACK_IMAGE;
  return salon.cover_image || salon.image_url || salon.logo_url || SALON_FALLBACK_IMAGE;
}
